import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const location = useLocation();
    const previousPathname = useRef(location.pathname);

    useLayoutEffect(() => {
        const isMonitorDetailsPage = location.pathname.match(/\/monitors\/[^/]+\/details/);
        const pathnameChanged = location.pathname !== previousPathname.current;

        if (isMonitorDetailsPage && !pathnameChanged) {
            previousPathname.current = location.pathname;
            return;
        }

        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        window.scrollTo(0, 0);

        const timeoutId = setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);

        previousPathname.current = location.pathname;

        return () => clearTimeout(timeoutId);
    }, [location.pathname, location.search]);

    return null;
};

export default ScrollToTop;